import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Button, TextField, Grid, MenuItem, InputAdornment, IconButton, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import PageTitle from '../../../shared/components/PageTitle';
import { Loader } from '../../../shared/components/Loader';
import { Formik } from 'formik';
import { useLocation, useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { addUpdatetrainingEvent, getArea, getCompany, getEmployee, getRegion, getScheduleSiteData, getTrainingListById } from '../../api';
import dayjs from 'dayjs';
import { ContentCopyOutlined } from '@mui/icons-material';
import GetAppIcon from '@mui/icons-material/GetApp';

const classTypeOptions = [
    'Accident Investigation Training',
    'Aerial Lift Training',
    'Aerial Lift Training Add Person',
    'Chainsaw Training',
    'Competent Person Training',
    'Confined Space Training',
    'Conflict De-Escalation Training',
    'CPR / Bleed Stop Training',
    'CPR / First Aid Training',
    'CPR Training',
    'Drivers Training',
    'Drivers Training Out-of-Town',
    'Employee Training',
    'Excavator Operator Training',
    'Fall Protection Training',
    'Flagger Training',
    'Forklift Training',
    'Forklift Training Add Person',
    'IST Training',
    'IST Training - Out-of-Town',
    'Scaffold Training',
    'Silica Training',
    'Skid Steer Operator Training',
    'Specialized Training',
    'Trenching & Excavation Training'
];

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        margin: theme.spacing(0),
    },
    withoutLabel: {
        marginTop: theme.spacing(0),
    },
    customToastProgress: {
        backgroundColor: '#F59300',
    },
}));

const UserWrapper = styled.div`
    position: relative;
    .css-sghohy-MuiButtonBase-root-MuiButton-root {
        background-color: #F59300 !important;
    }
    .css-1rwt2y5-MuiButtonBase-root-MuiButton-root {
        border : 1px solid #F59300 !important;
        color : #F59300 !important;
    }

    .wrapperWhite {
        background-color: #ffffff;
        padding: 1.5rem;
        border-radius: 18px;
    }

    .MuiTextField-root {
        width: 100%;
    }

    .card-box{
        position: relative;
        overflow: hidden;
        box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
        border-radius: 0.5rem;
        color: rgba(0, 0, 0, 0.87);
        transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
        background-color: #fff;        
        cursor: pointer;
    }
    .card-indicator {
        position: absolute;
        height: 60%;
        top: 20%;
        width: 0px;
        border-top-right-radius: .75rem;
        border-bottom-right-radius: .75rem;
        left: 0;
        transition: all 0.3s linear;
    }
    .badge-primary {
        color: #fff;
        font-weight: 500;    
    }
    .roleName {
        font-size: 14px;
        font-weight: 500;
    }
    .roleItems { 
        width: 100%;
        height: 100%;
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }
    .roleItems:checked ~ .card-indicator {
        width: 6px;
    }
    .customWidth : {
        width : 100% !important
    }
`;

export default function AddTrainingSchedule() {
    const classes = useStyles();
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const isAddMode = location.pathname.includes("/add");
    const isViewMode = location.pathname.includes("/view/");
    var [rows, setRows] = React.useState([]);
    var [userData, setUserData] = React.useState([]);
    var [loading, setLoading] = React.useState(false);
    var [copied, setCopied] = React.useState(false);
    var [qrCopied, setQrCopied] = React.useState(false);
    var [qrDownloaded, setQrDownloaded] = React.useState(false);
    var [userEmail, setUserEmail] = React.useState("");
    var [company, setCompany] = React.useState("");
    var [clientList, setClientList] = React.useState([]);
    var [region, setRegion] = React.useState("");
    var [regionList, setRegionList] = React.useState([]);
    var [area, setArea] = React.useState("");
    var [areaList, setAreaList] = React.useState([]);
    var [siteData, setSiteData] = React.useState([]);
    const addTrainingEventMsg = () => toast("Training Event Added Successfully!", { progressClassName: classes.customToastProgress });
    const updateTrainingEventMsg = () => toast("Training Event Updated Successfully!", { progressClassName: classes.customToastProgress });
    const errorMessage = () => toast("An error occured, try again later!", { progressClassName: classes.customToastProgress });

    useEffect(() => {
        let userProfile = localStorage.getItem("userProfile");
        userProfile = JSON.parse(userProfile);
        userEmail = userProfile?.userEmail;
        setUserEmail(userEmail);

        getUserData();
        fetchCompany(userEmail);
        fetchTrainingList();
    }, []);

    const fetchTrainingList = async () => {
        if (id) {
            try {
                const res = await getTrainingListById(id);
                if (res.data.successCode === 0) {
                    rows = res.data.data
                    setRows(rows);
                    if (rows.clientId != null) {
                        company = rows?.clientId
                        setCompany(company)
                        fetchRegion(company)
                        region = rows?.regionId
                        setRegion(region);
                        fetchArea(region);
                        area = rows?.areaId
                        setArea(area);
                        fetchSiteData(area);
                    }
                } else {
                    errorMessage();
                }
            } catch (error) {
                errorMessage();
            }
        }
    }

    const getUserData = async () => {
        setLoading(true);
        try {
            const res = await getEmployee();
            if (res.data.successCode === 0) {
                userData = res.data.data
                setUserData(userData);
            }
        } catch (error) {
            errorMessage();
        } finally {
            setLoading(false);
        }
    }

    const fetchCompany = async (userEmail) => {
        try {
            const res = await getCompany(userEmail);
            if (res.data.successCode === 0) {
                clientList = res.data.data
                setClientList(clientList);
            }
        } catch (error) {
            errorMessage();
        }
    }

    const fetchRegion = async (company) => {
        try {
            const res = await getRegion(company);
            if (res.data.successCode === 0) {
                regionList = res.data.data
                setRegionList(regionList);
            }
        } catch (error) {
            errorMessage();
        }
    }

    const fetchArea = async (regionId) => {
        try {
            const res = await getArea(regionId);
            if (res.data.successCode === 0) {
                areaList = res.data.data
                setAreaList(areaList);
            }
        } catch (error) {
            errorMessage();
        }
    }

    const fetchSiteData = async (area) => {
        try {
            const res = await getScheduleSiteData(userEmail, company, region, area);
            if (res.data.successCode === 0) {
                siteData = res.data.data
                setSiteData(siteData);
            }
        } catch (error) {
            errorMessage();
        }
    }

    const customHandleChange = (e) => {
        company = e.target.value
        setCompany(company);
        fetchRegion(company);
    }

    const handleRegionChange = (e, handleChange) => {
        region = e.target.value
        setRegion(region);
        handleChange(e);
        fetchArea(region);
    }

    const handleAreaChange = (e, handleChange) => {
        area = e.target.value
        setArea(area);
        handleChange(e);
        fetchSiteData(area);
    }

    const downloadQrCode = (qrCode) => {
        Object.assign(document.createElement("a"), {
            href: `data:image/png;base64,${qrCode}`,
            download: "qr_code.png"
        }).click();
    }

    if (loading) {
        return (
            <div className="d-flex align-items-center vh-100 justify-content-center text-center font-weight-bold font-size-lg py-3">
                <Loader color="#ff9900" />
            </div>
        );
    }

    return (
        <Formik
            enableReinitialize={true}
            initialValues={{
                Title: rows?.title,
                EmployeeId: rows?.employeeId,
                Description: rows?.description,
                clientId: rows?.clientId,
                Region: rows?.regionId,
                Area: rows?.areaId,
                SiteId: rows?.siteId,
                Location: rows?.location,
                trainingStartDate: rows?.trainingStartDate,
                ContactName: rows?.contactName,
                ContactPhone: rows?.contactPhone,
                AddParticipantUrl: rows?.addParticipantUrl,
                QrCode: rows?.qrCode

            }}
            validate={values => {

                const errors = {};

                if (!values.Title) {
                    errors.Title = 'Required!';
                }
                if (!values.EmployeeId) {
                    errors.EmployeeId = 'Required!';
                }
                if (!values.Description) {
                    errors.Description = 'Required!';
                }
                if (!company) {
                    errors.clientId = 'Required!';
                }
                if (!values.Region) {
                    errors.Region = 'Required!';
                }
                if (!values.Area) {
                    errors.Area = 'Required!';
                }
                if (!values.SiteId) {
                    errors.SiteId = 'Required!';
                }
                if (!values.Location) {
                    errors.Location = 'Required!';
                }
                if (!values.trainingStartDate) {
                    errors.trainingStartDate = 'Required!';
                }
                if (!values.ContactName) {
                    errors.ContactName = 'Required!';
                }
                if (!values.ContactPhone) {
                    errors.ContactPhone = 'Required!';
                }

                return errors;
            }}

            const handleMouseDownPwd={(event) => {
                event.preventDefault();
            }}
            onSubmit={async (values, { setSubmitting }) => {
                const postData = {
                    id: id ? String(id) : "0",
                    title: values.Title,
                    employeeId: values.EmployeeId,
                    description: values.Description,
                    siteId: values.SiteId,
                    location: values.Location,
                    trainingStartDate: values.trainingStartDate ? dayjs(values.trainingStartDate).format('YYYY-MM-DDTHH:mm:ss') : null,
                    contactName: values.ContactName,
                    contactPhone: values.ContactPhone
                }

                try {
                    const res = await addUpdatetrainingEvent(postData);
                    if (res.data.successCode === 0) {
                        { id ? updateTrainingEventMsg() : addTrainingEventMsg() }
                    } else {
                        errorMessage();
                    }
                    setTimeout(() => { navigate("/schedule") }, 3000);
                } catch (error) {
                    errorMessage();
                    setTimeout(() => { navigate("/schedule") }, 3000);
                }
                setSubmitting(false)
            }}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                setFieldValue,
                handleSubmit,
                isSubmitting
            }) => (
                <form onSubmit={handleSubmit}>
                    <UserWrapper>
                        <ToastContainer theme='dark' />
                        <Grid container spacing={4} className='d-flex justify-content-center'>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <PageTitle>Training Event</PageTitle>
                            </Grid>

                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField className="filterDropdown" id="classType" select label="Class Type" helperText="" variant="standard" name="Title" value={values.Title || ""} onBlur={handleBlur} onChange={handleChange} InputProps={{ readOnly: isViewMode, }} sx={{ '& .MuiSelect-select': { cursor: isViewMode ? 'default !important' : 'pointer', }, }}>
                                    {classTypeOptions.map(option => (
                                        <MenuItem key={option} value={option}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.Title && touched.Title && errors.Title}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField className="filterDropdown" id="status" select label="Select Employee" helperText="" variant="standard" name="EmployeeId" value={values.EmployeeId || ""} onBlur={handleBlur} onChange={handleChange} InputProps={{ readOnly: isViewMode, }} sx={{ '& .MuiSelect-select': { cursor: isViewMode ? 'default !important' : 'pointer', }, }}>
                                    {userData.map(option => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.EmployeeId && touched.EmployeeId && errors.EmployeeId}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField label="Description" variant="standard" name="Description" multiline value={values.Description || ""} onChange={handleChange} onBlur={handleBlur} InputProps={{ readOnly: isViewMode, inputProps: { style: { cursor: isViewMode ? "default" : "auto" } } }} />
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.Description && touched.Description && errors.Description}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField className="filterDropdown" id="clientId" select label="Select Company" helperText="" variant="standard" value={company || ""} name="clientId" onChange={(e) => customHandleChange(e)} onBlur={handleBlur} InputProps={{ readOnly: isViewMode, }} sx={{ '& .MuiSelect-select': { cursor: isViewMode ? 'default !important' : 'pointer', }, }}>
                                    {clientList.map(option => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.clientId && touched.clientId && errors.clientId}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField className="filterDropdown" id="region" select label="Select Region" helperText="" variant="standard" value={values.Region || ""} name="Region" onChange={(e) => handleRegionChange(e, handleChange)} onBlur={handleBlur} InputProps={{ readOnly: isViewMode, }} sx={{ '& .MuiSelect-select': { cursor: isViewMode ? 'default !important' : 'pointer', }, }}>
                                    {regionList.map(option => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.Region && touched.Region && errors.Region}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField className="filterDropdown" id="Area" select label="Select Area" helperText="" variant="standard" name="Area" value={values.Area || ""} onChange={(e) => handleAreaChange(e, handleChange)} onBlur={handleBlur} InputProps={{ readOnly: isViewMode, }} sx={{ '& .MuiSelect-select': { cursor: isViewMode ? 'default !important' : 'pointer', }, }}>
                                    {areaList.map(option => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.Area && touched.Area && errors.Area}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField className="filterDropdown" id="SiteId" select label="Select Site" helperText="" variant="standard" name="SiteId" value={values.SiteId || ""} onChange={handleChange} onBlur={handleBlur} InputProps={{ readOnly: isViewMode, }} sx={{ '& .MuiSelect-select': { cursor: isViewMode ? 'default !important' : 'pointer', }, }}>
                                    {siteData.map(option => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.siteName}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.SiteId && touched.SiteId && errors.SiteId}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField label="Location" variant="standard" name="Location" multiline value={values.Location || ""} onChange={handleChange} onBlur={handleBlur} InputProps={{ readOnly: isViewMode, inputProps: { style: { cursor: isViewMode ? "default" : "auto" } } }} />
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.Location && touched.Location && errors.Location}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DateTimePicker']}>
                                        <DateTimePicker
                                            label="Date and Time"
                                            value={values.trainingStartDate ? dayjs(values.trainingStartDate) : null}
                                            onChange={(newValue) => {
                                                if (newValue) {
                                                    setFieldValue('trainingStartDate', newValue);
                                                }
                                            }}
                                            onAccept={(newValue) => {
                                                if (newValue) {
                                                    setFieldValue('trainingStartDate', newValue);
                                                }
                                            }}
                                            closeOnSelect={false}
                                            disablePast
                                            readOnly={isViewMode}
                                            slotProps={{ textField: { inputProps: { style: { cursor: isViewMode ? 'default' : 'auto' }, }, }, }}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.trainingStartDate && touched.trainingStartDate && errors.trainingStartDate}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField label="Contact Name" variant="standard" name="ContactName" value={values.ContactName || ""} onChange={handleChange} onBlur={handleBlur} InputProps={{ readOnly: isViewMode, inputProps: { style: { cursor: isViewMode ? "default" : "auto" } } }} />
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.ContactName && touched.ContactName && errors.ContactName}</div>
                            </Grid>
                            <Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField label="Contact Phone" variant="standard" name="ContactPhone" value={values.ContactPhone || ""} onChange={handleChange} onBlur={handleBlur} InputProps={{ readOnly: isViewMode, inputProps: { style: { cursor: isViewMode ? "default" : "auto" } } }} />
                                <div className="errMsg" style={{ marginTop: '5px' }}>{errors.ContactPhone && touched.ContactPhone && errors.ContactPhone}</div>
                            </Grid>
                            {!isAddMode && (<Grid item xs={12} sm={8} md={8} className="pt-3">
                                <TextField
                                    label="Url"
                                    value={values.AddParticipantUrl || ""}
                                    variant="standard"
                                    fullWidth
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Tooltip title="Copied!" open={copied} placement="top">
                                                    <IconButton onClick={() => { navigator.clipboard.writeText(values.AddParticipantUrl); setCopied(true); setTimeout(() => setCopied(false), 1500); }}>
                                                        <ContentCopyOutlined fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>)}

                            {!isAddMode && values.QrCode && (
                                <Grid item xs={12} sm={8} md={8} className="pt-3">
                                    <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px' }}>
                                        <div>
                                            <div style={{ fontSize: '12px', color: 'rgba(0,0,0,0.6)', marginBottom: '6px' }}>QR Code</div>
                                            <img src={`data:image/png;base64,${values.QrCode}`} alt="QR Code" style={{ width: 120, height: 120, border: '1px solid #ddd', borderRadius: 4 }} />
                                        </div>
                                        <div>
                                            <Tooltip title="Copied!" open={qrCopied} placement="top">
                                                <IconButton onClick={() => { navigator.clipboard.writeText(values.QrCode); setQrCopied(true); setTimeout(() => setQrCopied(false), 1500); }}>
                                                    <ContentCopyOutlined fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title={"Downloaded!"} open={qrDownloaded} placement="top">
                                                <IconButton onClick={() => { downloadQrCode(values.QrCode); setQrDownloaded(true); setTimeout(() => setQrDownloaded(false), 1500) }}>
                                                    <GetAppIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    </div>
                                </Grid>
                            )}

                            <Grid item xs={12} sm={8} md={8} className="text-right mt-4">
                                <Button type="button" variant="outlined" color="primary" className="noShadow cancelBtn" onClick={() => navigate("/schedule")}>
                                    Cancel
                                </Button>&nbsp;&nbsp;
                                {!isViewMode && (<Button type="submit" variant="contained" color="primary" className="noShadow addBtn" disabled={isSubmitting}>
                                    Submit
                                </Button>)}
                            </Grid>
                        </Grid>
                    </UserWrapper>
                </form>
            )}
        </Formik>
    );
};